var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Banner, Box, DialogContent, DialogFooter, DialogHeader, Typography, useToast } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { CancelButton, FormDialog, FormValidationErrors, SubmitButton } from 'shared/domains/forms';
import { FieldSelection } from './FieldSelection';
import { getValidationSchema } from './validationSchema';
import { useHubspotSyncFields } from '../useHubspotSyncFields';
import { usePushHubspotMetadataFieldValues } from '../usePushHubspotMetadataFieldValues';
export function SendToHubspotDialog(props) {
    const { fieldMapping, objectId, onClose } = props;
    const { addToast } = useToast();
    const fields = useHubspotSyncFields(fieldMapping.mappings.map((mapping) => mapping.miramisMetadataId));
    const [pushValues] = usePushHubspotMetadataFieldValues();
    const hasFields = fields.length > 0;
    const handleSubmit = (values) => __awaiter(this, void 0, void 0, function* () {
        try {
            const fieldValues = fields
                .filter((field) => values.selectedIds.includes(field.id))
                .map((field) => ({ miramisMetadataId: field.id, value: field.value }));
            yield pushValues(fieldMapping.id, objectId, fieldValues);
            addToast({
                title: t({
                    message: 'Metadata sent to HubSpot',
                    comment: 'HubSpot metadata: toast message when metadata was sent to HubSpot',
                }),
                appearance: 'success',
            });
            onClose();
        }
        catch (_a) {
            addToast({
                title: t({
                    message: 'Failed to send metadata to HubSpot',
                    comment: 'HubSpot metadata: toast message when sending metadata to HubSpot fails',
                }),
                appearance: 'danger',
            });
        }
    });
    return (<FormDialog size="md" initialValues={{ selectedIds: [] }} validationSchema={getValidationSchema()} onSubmit={handleSubmit} onClose={onClose}>
      <DialogHeader icon={<Falcon icon="hubspot" sourceConfig={{ family: 'classic', style: 'brands' }}/>} title={t({
            message: 'Send metadata values to HubSpot',
            comment: 'HubSpot metadata: dialog title',
        })}/>
      <DialogContent>
        {hasFields ? (<Box flexDirection="column" gap="xl" pb="3xl">
            <Typography $fontSize="small">
              <Trans comment="HubSpot metadata: dialog content">Select which properties to sync to HubSpot.</Trans>
            </Typography>

            <FieldSelection fields={fields}/>

            <FormValidationErrors title={t({
                message: 'Please fix the following errors',
                comment: 'HubSpot metadata: form validation errors title',
            })}/>
          </Box>) : null}

        {hasFields ? (<Banner appearance="info">
            <Falcon icon="exclamation-triangle"/>
            <Trans comment="HubSpot metadata: overwrite warning">
              Existing values in the selected HubSpot properties will be overwritten.
            </Trans>
          </Banner>) : (<Banner appearance="info">
            <Falcon icon="circle-info"/>
            <Trans comment="HubSpot metadata: no values to sync">There are no metadata values to sync.</Trans>
          </Banner>)}
      </DialogContent>
      <DialogFooter>
        <CancelButton onClick={onClose}>
          <Trans comment="HubSpot metadata: cancel dialog">Cancel</Trans>
        </CancelButton>
        <SubmitButton disabled={!hasFields}>
          <Trans comment="HubSpot metadata: confirm send">Send to HubSpot</Trans>
        </SubmitButton>
      </DialogFooter>
    </FormDialog>);
}
